import CMLoggingList from "./LoggingList";

export default {
  list: CMLoggingList,
};
